// eslint-disable-next-line import/prefer-default-export
export const FETCH_USER_PERMISSIONS = 'FETCH_USER_PERMISSIONS';
export const FETCH_USER_PERMISSIONS_SUCCESS = 'FETCH_USER_PERMISSIONS_SUCCESS';
export const FETCH_USER_PERMISSIONS_FAIL = 'FETCH_USER_PERMISSIONS_FAIL';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';

// ReassignUsers
export const SET_BRAND_PROFILE_ID = 'SET_BRAND_PROFILE_ID';
export const TOGGLE_CONFIRM_MODAL = 'TOGGLE_CONFIRM_MODAL';
export const FETCH_STORIES = 'FETCH_STORIES';
export const SET_STORIES = 'SET_STORIES';
export const FETCH_ELIGIBLE_USERS = 'FETCH_ELIGIBLE_USERS';
export const SET_ELIGIBLE_USERS = 'SET_ELIGIBLE_USERS';
export const START_REASSIGNMENT_JOB = 'START_REASSIGNMENT_JOB';
export const HANDLE_POLLING_JOB_STATUS = 'HANDLE_POLLING_JOB_STATUS';
export const HANDLE_JOB_ID = 'HANDLE_JOB_ID';
export const SET_JOB_ID = 'SET_JOB_ID';
export const SET_JOB_STATUS = 'SET_JOB_STATUS';
export const SET_PERSISTED_JOB_STATUS = 'SET_PERSISTED_JOB_STATUS';
export const HANDLE_JOB_RESTART = 'HANDLE_JOB_RESTART';
export const REMOVE_PERSISTED_JOB_STATUS = 'REMOVE_PERSISTED_JOB_STATUS';
export const RESET_FORM = 'RESET_FORM';

// Localize
export const PREFERRED_LANG_CHANGED = 'PREFERRED_LANG_CHANGED';



// WEBPACK FOOTER //
// ./app/javascript/app/store/actions/actionTypes.js